var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "228px",
    height: "50px",
    viewBox: "0 0 228 50",
    fill: "none",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5151 0.363708V25.1386H79.9099V15.2061H91.6003V10.2442H79.9099V5.31695H93.1763V0.363708H74.5151Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.427 0.337708V15.5958L104.823 0.337708H99.7922V25.1126H105.17V9.36092L117.172 25.1126H121.813V0.337708H116.427Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.904 0.320374L141.903 15.5351L135.911 0.320374H128.429V25.1299H133.798V8.64216L140.76 25.1299H143.055L150.017 8.64216V25.1299H155.378V0.320374H147.904Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28715 20.9993L0 29.2778H57.9581L66.2539 20.9993H8.28715Z",
    fill: "url(#paint0_linear_5_107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9581 0.337708H8.28717V16.8687H57.9581V0.337708Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9581 33.469H8.28717V50H57.9581V33.469Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2726 37.5043V49.8528H76.9657V44.8996H82.7935V42.4316H76.9657V39.9809H83.5729V37.5043H74.2726Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.168 37.4957V45.0987L89.3835 37.4957H86.8722V49.8441H89.5566V41.99L95.5404 49.8441H97.8524V37.4957H95.168Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.859 37.487L107.863 45.0727L104.875 37.487H101.143V49.8528H103.828V41.6349L107.291 49.8528H108.434L111.907 41.6349V49.8528H114.583V37.487H110.859Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.922 49.9567C124.105 49.9879 123.29 49.8485 122.529 49.5472C121.769 49.2459 121.079 48.7894 120.505 48.2069C119.93 47.6244 119.484 46.9286 119.193 46.1638C118.902 45.3991 118.774 44.5822 118.817 43.7652C118.795 42.9591 118.934 42.1567 119.226 41.405C119.518 40.6533 119.958 39.9675 120.518 39.3876C121.079 38.8078 121.749 38.3457 122.491 38.0282C123.232 37.7108 124.029 37.5445 124.835 37.539C126.481 37.4681 128.089 38.0395 129.321 39.1324L128.455 40.1628C127.966 39.7045 127.392 39.3471 126.765 39.1108C126.138 38.8746 125.471 38.7642 124.801 38.786C124.174 38.8036 123.557 38.9464 122.987 39.2059C122.416 39.4654 121.903 39.8364 121.478 40.2971C121.053 40.7578 120.724 41.2989 120.511 41.8886C120.298 42.4782 120.205 43.1045 120.237 43.7305C120.237 46.6142 122.073 48.7444 124.991 48.7444C126.248 48.7391 127.466 48.3156 128.455 47.5408V44.5532H124.801V43.3322H129.763V48.1209C128.429 49.3051 126.706 49.9583 124.922 49.9567Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.072 49.7576L137.608 45.0901H134.144V49.7576H132.785V37.7382H137.981C140.622 37.7382 142.31 39.167 142.31 41.3319C142.31 43.3322 140.942 44.5013 139.054 44.8476L142.743 49.7576H141.072ZM137.868 38.9938H134.162V43.8691H137.851C139.652 43.8691 140.942 42.9425 140.942 41.3838C140.942 39.8251 139.851 38.9938 137.868 38.9938Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.797 49.9567C149.567 49.9704 148.36 49.6184 147.331 48.9454C146.301 48.2723 145.494 47.3085 145.013 46.1763C144.532 45.044 144.398 43.7944 144.628 42.5859C144.859 41.3775 145.443 40.2647 146.306 39.3888C147.17 38.5128 148.275 37.9132 149.48 37.666C150.685 37.4188 151.936 37.5352 153.075 38.0004C154.214 38.4655 155.189 39.2585 155.876 40.2787C156.564 41.2989 156.933 42.5003 156.936 43.7305C156.959 44.5469 156.816 45.3593 156.516 46.1191C156.216 46.8788 155.766 47.5702 155.193 48.1517C154.62 48.7332 153.935 49.1928 153.179 49.503C152.424 49.8132 151.613 49.9675 150.797 49.9567ZM150.797 38.786C150.159 38.7876 149.527 38.9184 148.941 39.1705C148.355 39.4225 147.826 39.7907 147.386 40.2527C146.946 40.7146 146.604 41.261 146.38 41.8587C146.157 42.4564 146.057 43.0931 146.086 43.7305C146.059 44.3712 146.162 45.0107 146.387 45.6109C146.613 46.2112 146.957 46.7599 147.399 47.2245C147.841 47.6891 148.371 48.06 148.96 48.3151C149.548 48.5703 150.181 48.7045 150.823 48.7097C151.46 48.7081 152.091 48.5773 152.677 48.3251C153.263 48.0729 153.791 47.7047 154.231 47.2426C154.67 46.7805 155.011 46.234 155.234 45.6364C155.456 45.0387 155.555 44.4022 155.525 43.7652C155.552 43.1253 155.449 42.4865 155.224 41.8868C155 41.2871 154.656 40.7387 154.215 40.2743C153.774 39.8098 153.244 39.4387 152.657 39.1831C152.07 38.9274 151.437 38.7924 150.797 38.786Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.622 44.6225C169.622 48.0863 167.614 49.9394 164.609 49.9394C161.604 49.9394 159.621 48.1209 159.621 44.7437V37.7555H160.972V44.6831C160.972 47.281 162.348 48.7357 164.643 48.7357C166.938 48.7357 168.263 47.3935 168.263 44.7697V37.7814H169.622V44.6225Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.087 45.5144H174.169V49.7576H172.818V37.7382H177.312C180.023 37.7382 181.806 39.1843 181.806 41.5656C181.824 44.1808 179.685 45.5144 177.087 45.5144ZM177.208 38.9938H174.169V44.2761H177.139C179.131 44.2761 180.438 43.2196 180.438 41.6176C180.438 40.0156 179.165 38.9938 177.225 38.9938H177.208Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.985 0.181869H171.025C176.498 0.181869 180.265 2.98752 180.265 7.78489V7.85418C180.265 13.0499 175.753 15.7777 170.566 15.7777H163.855V25.0173H162.002L161.985 0.181869ZM170.644 14.0371C175.268 14.0371 178.386 11.6211 178.386 7.92347V7.85418C178.386 3.9141 175.338 1.85315 170.861 1.85315H163.829V14.0371H170.644ZM192.674 0H194.449L206.027 25.0173H204.009L200.849 18.0897H186.179L183.01 25.0173H181.096L192.674 0ZM200.061 16.4098L193.54 2.02635L186.967 16.4098H200.061ZM215.475 15.2061L204.797 0.181869H207.101L216.41 13.5348L225.753 0.181869H227.953L217.302 15.1715V25.0173H215.449L215.475 15.2061Z",
    fill: "url(#paint1_linear_5_107)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_107",
    x1: 0,
    y1: 25.1386,
    x2: 66.2539,
    y2: 25.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    "data-originalstopcolor": "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffffff",
    "data-originalstopcolor": "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ffffff",
    "data-originalstopcolor": "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    "data-originalstopcolor": "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_107",
    x1: 227.979,
    y1: 12.5217,
    x2: 161.985,
    y2: 12.5217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    "data-originalstopcolor": "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ffffff",
    "data-originalstopcolor": "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ffffff",
    "data-originalstopcolor": "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    "data-originalstopcolor": "#ffffff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227.979,
    height: 50,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvgWhite);
export default __webpack_public_path__ + "static/media/logo_svg_white.6d528157ea681f55af0cf1a0ee430dc1.svg";
export { ForwardRef as ReactComponent };